import React, { useEffect, useState } from 'react';
import InputLinks from '../Assets/linksData'
import BackCard from '../Assets/backCard'
import { Fade } from 'react-reveal';
import { Button,  Divider,  Dropdown, Icon, Input, Label, Loader, Form, Select, Tab, TextArea } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import GConf from '../../../AssetsM/generalConf';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup,   useMapEvents , useMap   } from 'react-leaflet';
import L from 'leaflet';

const GeneralData = ({entreData, setEntreData, Offline, SaveEntree, delegList, loaderState, setSetectedTag, options, gettedPID, saveBtnState}) =>{
    return(<>
        <div className='card card-body border-div shadow-sm mb-3'>
            <h3> PID: {gettedPID ? gettedPID : 0}</h3>
            <h5 className='mb-0'>Selectionez TAG </h5> 
            <Dropdown
                search
                fluid
                selection
                wrapSelection={false}
                options={options}
                placeholder='Selectionez UN Tableaux'
                onChange={(e, { value }) => setSetectedTag(value)}
            />
            <br />
            <div className='mb-4'>
                <h5 className='mb-0'> Nom  </h5>
                <Input fluid icon='users' iconPosition='left'  placeholder='Nom' value={entreData.Name} onChange={(e) => setEntreData({...entreData, Name: e.target.value })}   />
            </div>
            <div className='mb-4'>
                <h5 className='mb-0'> Telephone  </h5>
                <Input fluid icon='phone' iconPosition='left'   placeholder='Tel' value={entreData.Phone} onChange={(e) => setEntreData({...entreData, Phone: e.target.value })}  />
            </div>
            <div className='mb-4'>
                <div className='mb-2 text-secondary'>Gouv :  {Offline.localData[0] ? Offline.localData[0].gouv : ''}</div>
                <div className='mb-2 text-secondary'>Deleg :  {Offline.localData[0] ? Offline.localData[0].deleg : ''}</div>
                <Select placeholder='Delegation ' fluid className='mb-2 shadow-sm' value={entreData.Deleg} options={delegList} onChange={(e, { value }) => setEntreData({...entreData, Deleg: e.target.value })} />
            </div>
            <div className='mb-4'>
                <h5 className='mb-0'> Adressse</h5>
                <Form>
                    <TextArea placeholder='Adresse'  value={entreData.Adress} onChange={(e) => setEntreData({...entreData, Adress: e.target.value })} />
                </Form>

                <div className='card-body'>
                    <Button disabled={saveBtnState} onClick={() => SaveEntree()} fluid className='rounded-pill bg-system-btn ' positive>  <Icon name='map pin' /> Enregistreé  <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/> </Button>
                </div>
            </div>        
        </div>
    </>)
}

/* Position */
const MapEventsHandler = ({ onLocationSelected }) => {
        useMapEvents({
        click: (e) => {
            const { lat, lng } = e.latlng;
            onLocationSelected({ lat, lng });
        },
        });
    
        return null;
}
const PositionCard = ({gettedPID, selectedTag, position, handleLocationSelected, myPosition, GetMyLocation, setLS }) =>{

    const UpdatePositionFunc = () =>{
        if (!gettedPID) {toast.error("Ajouter un membre d'abord  !", GConf.TostErrorGonf)}
        else if (!position.Lat) {toast.error("position Invalide !", GConf.TostErrorGonf)}
        else if (!position.Lng ) {toast.error("position Invalide !", GConf.TostErrorGonf)}
        else{
            setLS(true)
            axios.post(`https://api.abyedh.com/api/systems/app/profile/update/position`, {
                PID : gettedPID,
                positionDataSent : [position.Lat, position.Lng],
                SystemTag : selectedTag
            }).then(function (response) {
                if(response.data.affectedRows) {
                    toast.success("Position Modifieé !", GConf.TostSuucessGonf)
                    setLS(false)
                }
                else{
                    toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                    setLS(false)
                }
            })                
        }
    }

    function RecenterMap({ position }) {
        const map = useMap();
      
        useEffect(() => {
          if (position?.Lat && position?.Lng) {
            map.setView([position.Lat, position.Lng]);
          }
        }, [position, map]);
      
        return null;
    }

    return(<>
        <div className='mb-3'>
                <Button  fluid className='rounded-pill mb-2 ' onClick={() => GetMyLocation()}>Ma Position </Button> 
                <MapContainer center={[position.Lat,position.Lng]} zoom={10} scrollWheelZoom={false} className=" cursor-map-crosshair border-div" style={{height:'400px'}}>
                    <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <MapEventsHandler onLocationSelected={handleLocationSelected} />
                    <RecenterMap position={position} />
                    <Marker position={[position.Lat,position.Lng]}>
                        <Popup> </Popup>
                    </Marker>
                    <Marker position={myPosition}>
                        <Popup> My Position </Popup>
                    </Marker>
                </MapContainer> 
                {/* <LocationPicker    />*/}
                <Button  fluid className='rounded-pill mb-2 mt-3 text-white' onClick={() => UpdatePositionFunc()} style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}}  > mettre le position a jour  </Button>
        </div>
    </>)
}

/*Horaire  */
const HoraireCard = ({alwaysState, setAlwaysState, timming, addInput, setTimming, setAddInput, selectedUpdateDay,  setSelectedUpdateDay}) =>{
     

    let [dateDataToChange, setDateDataToChange] = useState({pauseDay: false, matinStart:'08:00', matinFinsh:'12:00', soirStart:'14:00', soirFinsh:'18:00'})
     
    const DayHoraire = (props) =>{
        return(<>
                <div className={`row  mb-1 ${props.data.dayOff ? 'text-danger':''}`}  >
                    <div  className='col-3 col-lg-3 m-0 p-1'>
                        <b>{props.data.day}</b>
                    </div>
                    <div  className='col-4 col-lg-4  m-0 p-1'>
                        <small>{props.data.matin.start} - {props.data.matin.end}</small>
                    </div>
                    <div  className='col-4 col-lg-4  m-0 p-1'>
                        <small>{props.data.soir.start} - {props.data.soir.end}</small>
                    </div>
                    <div className='col-1 m-0 p-1'>
                        <span className='bi bi-pencil-square bi-xsm text-secondary' onClick={() => OpenEditTime(props.data.day)}></span>
                    </div>
                </div>
        </>)
    }

    const OpenEditTime = (value) =>{
        setSelectedUpdateDay(value)
        setAddInput(true)
    }

    const UpdateTimingFunc = () =>{
        const targetIndex = timming.findIndex(element => element.day === selectedUpdateDay)
        let copyOfHoraire = timming
        copyOfHoraire[targetIndex] = {day: selectedUpdateDay , dayOff: dateDataToChange.pauseDay , matin:{start: dateDataToChange.matinStart ,end: dateDataToChange.matinFinsh},soir:{start: dateDataToChange.soirStart,end: dateDataToChange.soirFinsh}}
        setTimming(copyOfHoraire)
         
        setAddInput(!addInput)
    }
    
    return(<>
        <br />
        <div className=' '  >
           
            <div className='row'>
                <div className='col-12 col-lg-12'>
                    <div className=' '>
                        <div className='row'>
                            <div className='col-10 col-lg-9 align-self-center'> 
                                <h5 className='mb-0 text-success'> Toujours ouvert </h5>  
                                <small>  En activant cette option, il apparaîtra comme toujours ouvert  </small>
                            </div>
                            <div className='col-2 col-lg-3  align-self-center '> 
                                <div className="form-check form-switch">
                                    <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setAlwaysState(!alwaysState)}  checked={alwaysState} />
                                </div>
                            </div>
                        </div>
                        <Divider />
                        <div className='row text-secondary mb-2'>
                            <div  className='col-4 col-lg-4'> <b> date </b> </div>
                            <div  className='col-4 col-lg-4'> <small>matin </small> </div>
                            <div  className='col-4 col-lg-4'> <small>soir </small> </div>
                        </div>
                        
                        {
                            timming.map( (data,index) => <DayHoraire key={index} data={data} />)
                        }
                        
                    </div>
                </div>
                 
            </div>
            {addInput ? 
            <div className='card-body not-focus-inside-this'  >
                        <div className='text-start'><span className='bi bi-x-circle-fill  text-danger text-secondary mb-2' onClick={() => setAddInput(!addInput)}></span></div>
                        <h5 className='mt-0'>   Est ce que c'est un jour de repos ?  </h5>
                        <Select autoSelect={false}  fluid options={[ { key: 'af', value: false, text: 'Non' }, { key: 'ax', value: true, text: 'Oui' }]} onChange={(e, {value}) => setDateDataToChange({... dateDataToChange, pauseDay : value})} className='mb-3'/>
                        <div className='row mb-3 '>
                            <div className='col-6'><Input  type='time' size='mini'  value={dateDataToChange.matinStart}  fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, matinStart : e.target.value})} /></div>
                            <div className='col-6'><Input  type='time' size="mini"  value={dateDataToChange.matinFinsh} fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, matinFinsh : e.target.value})}/></div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-6'><Input  type='time' size='mini'  value={dateDataToChange.soirStart}   fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, soirStart : e.target.value})} /></div>
                            <div className='col-6'><Input  type='time' size="mini"  value={dateDataToChange.soirFinsh}  fluid className='mb-1 w-100'  onChange={(e) => setDateDataToChange({... dateDataToChange, soirFinsh : e.target.value})}/></div>
                        </div>
                        <Button size='mini'     className='rounded-pill    font-droid' onClick={() => UpdateTimingFunc()} fluid  >   <Icon name='time' />  Modifier l'horaire de ce jour !  </Button>
                    </div>
                    :
                    <></>}
        </div>
    </>)
}


function NouveauxInput() {
    /*#########################[Const]##################################*/
    const Today = new Date()
    let Offline = JSON.parse(localStorage.getItem(`Admin_Dir_Offline`));
    
    /*General Info  */
    const [selectedTag, setSetectedTag] = useState(); 
    const [gettedPID, setPID] = useState() 
    
    const [entreData, setEntreData] = useState({Name :'', Phone:'', Adress :'' , Gouv: Offline.localData[0] ? Offline.localData[0].gouv : '' , Deleg: Offline.localData[0] ? Offline.localData[0].deleg : ''})
    const [saveBtnState, setSaveBtnState] = useState(false)
    const [loaderState, setLS] = useState(false)
    const [delegList ,setDelegList] = useState([])

    /*Position */
    let [position, setPosition] = useState({Lat: 36.83040, Lng: 10.13280})
    const [myPosition, setMyPosition] = useState([36.17720,9.12337]) 
    L.Icon.Default.mergeOptions(GConf.LeafleftIcon );
    const icon = L.icon(GConf.LeafleftIconP);

    
    /*Images */
    const [imageLink, setImageLink] = useState('')
    const [loadingState, setLoadingState] = useState(false);
    const [profilePhotoData, setProfilePhotoData] = useState({});
    const [disabledSaveBtn, setDisabledBtn] = useState(false)
    const [toDeleteId, setToDeleteID] = useState('')
    
    /*Profile Picture  */
    const [todisplayedImage, setToDisplayedImage] = useState([])
    const [formaDataArr, setFormDataArr] = useState()

     
    /*Timing  */
    let [selectedUpdateDay , setSelectedUpdateDay] = useState('Lun')
    let [alwaysState , setAlwaysState] = useState(false)
    let [timming, setTimming] = useState([{day:"Lun",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Mar",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Mer",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Jeu",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Vend",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Sam",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Dim",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}}])
    let [addInput, setAddInput] = useState(false)

    const options = [
        { key: 1, text: 'docteur', value: 'docteur'},
        { key: 2, text: 'pharmacie', value: 'pharmacie'},
        { key: 3, text: 'clinique', value: 'clinique'},
        { key: 4, text: 'laboratoire', value: 'labo'},
        { key: 5, text: 'centre medicale', value: 'centreMD'},
        { key: 6, text: 'Hopitale', value: 'admin_s_hospital'},
        { key: 7, text: 'centre de soins de base', value: 'admin_s_csb'},
        
        { key: 8, text: 'garderie', value: 'garderie' },
        { key: 9, text: 'ecole Priveé', value: 'ecole' },
        { key: 10, text: 'Lycee Priveé', value: 'lycee' },
        { key: 11, text: 'Universite Priveé', value: 'universite' },
        { key: 12, text: 'Formation', value : 'formation' },
        { key: 13, text: 'Librairie',value : 'librairie' },
        { key: 14, text: 'centre de formation', value: 'admin_e_centre' },
        { key: 15, text: 'bibliothéque ', value: 'admin_e_biblio' },
        { key: 151, text: 'Ecole Publique  ', value: 'admin_e_ecole' },
        { key: 152, text: 'Lycee Publique  ', value: 'admin_e_lycee' },
        { key: 153, text: 'Universite Piblique  ', value: 'admin_e_universite' },
        { key: 154, text: 'Rectorat ', value: 'admin_e_ss' },
        
        { key: 16, text: 'Transporteur',  value: 'transporteur' },
        { key: 17, text: 'Autoecole', value: 'autoecole' },
        
        { key: 18, text: 'Cafe', value: 'cafe' },
        { key: 19, text: 'Restaurant', value: 'restaurant' },
        { key: 59, text: 'Hotels',  value: 'hotels' },
        { key: 60, text: 'travel agency ', value: 'vg_agence' },

        { key: 20, text: 'Magazin', value: 'magazin' },
        { key: 21, text: 'Boulengerie', value: 'boulengerie' },
        { key: 22, text: 'Boucherie', value: 'boucherie' },
        { key: 23, text: 'Fruiterie', value: 'fruiterie' },
        { key: 24, text: 'Patesserie', value: 'patesserie' },
        { key: 25, text: 'Epecerie', value: 'epicerie' },
        { key: 26, text: 'Electromenager', value: 'electromenager' },
        { key: 27, text: 'Meuble', value: 'meublerie' },
        { key: 33, text: 'Quicaillerie', value: 'quincaillerie' },
        { key: 39, text: 'boutique', value: 'boutique' },
        { key: 55, text: 'Vente en gros', value: 'depot' },

        { key: 28, text: 'Location voiture', value: 'location' },
        { key: 29, text: 'Parking', value: 'parking' },
        
        { key: 30, text: 'Samsar ', value: 'courtier' },
        { key: 31, text: 'Contracteur', value: 'contracteur' },
        { key: 32, text: 'Architequte', value: 'architecture' },
        
        
        { key: 34, text: 'Forgeron', value: 'forgeron' },
        { key: 35, text: 'menuisier', value: 'menuisier' },
        { key: 36, text: 'peinture', value: 'peinture' },
        { key: 37, text: 'electricien', value: 'electricien' },
        { key: 371, text: 'Plombier', value: 'plombier' },
        { key: 372, text: 'cristalerie', value: 'cristalerie' },
        { key: 373, text: 'marbrerie', value: 'marbrerie' },
        
        { key: 38, text: 'coiffure', value: 'coiffure' },
        { key: 40, text: 'Salon marriage', value: 'salle_marriage' },
        { key: 41, text: 'Orchestre', value: 'orchestre' },
        { key: 42, text: 'Chef Cuisine', value: 'chef' },
        { key: 43, text: 'Photographe', value: 'photographe' },
        { key: 44, text: 'Vente fourniture marriage', value: 'fourniture_marriage' },
        { key: 45, text: 'Bijouterie', value: 'bijouterie' },
        
        { key: 46, text: 'Salle de sport',  value: 'gym' },
        { key: 47, text: 'Piscine',  value: 'pyscine' },
        { key: 48, text: 'Stade',  value: 'stade' },
        { key: 49, text: 'Cinema',  value: 'cinema' },
        { key: 50, text: 'Theatre', value: 'theatre' },
        { key: 51, text: 'Musee',  value: 'musee' },
        { key: 52, text: 'maison des jeunes ',  value: 'admin_c_mj' },
        { key: 53, text: 'maison de culture ', value: 'admin_c_mc' },
       
        { key: 54, text: 'Avocat',  value: 'avocat' },
        
        { key: 56, text: 'Comptable',  value: 'comptable' },
        { key: 58, text: 'Buerux de Poste ', value: 'admin_f_poste' },
        
        { key: 61, text: 'Municipaliteé',  value: 'admin_a_mu' },
        { key: 62, text: 'Agence de Police', value: 'admin_a_police' },
        { key: 63, text: 'Admin Regionale ',  value: 'admin_a_ar' },
        { key: 64, text: 'Court ',  value: 'admin_a_court' },


    ]

    const panes = [
        {
            menuItem: { key: 'start', icon: 'add circle', content: 'Info ' }, 
            render: () => <GeneralData entreData={entreData} setEntreData={setEntreData} Offline={Offline} SaveEntree={SaveEntree} loaderState={loaderState} setSetectedTag={setSetectedTag} delegList={delegList} options={options} gettedPID={gettedPID} saveBtnState={saveBtnState} />,
        },
        {
            menuItem: { key: 'stfffart', icon: 'map marker alternate', content: 'Position ' },
            render: () =>  <PositionCard gettedPID={gettedPID} selectedTag={selectedTag} position={position} handleLocationSelected={handleLocationSelected} myPosition={myPosition} GetMyLocation={GetMyLocation} setLS={setLS} />,
        },
        {
            menuItem: { key: 'imageprofile', icon: 'user circle', content: 'Im. Profile' }, 
            render: () => <ProfileImage />,
        }, 
        {
            menuItem: { key: 'client', icon: 'image', content: 'Images' }, 
            render: () => <ImageCard />,
        },  
        {
            menuItem: { key: 'fdff', icon: 'time', content: 'Horaire' }, 
            render: () =><HoraireTabs />,
        },     
    ]

    /*#########################[Use Effect]##################################*/
    useEffect(() => {
        //get position 
        navigator.geolocation.getCurrentPosition(
            function(position) {
                if (!position.coords.latitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lat</h5></div></>, GConf.TostInternetGonf)}
                else if (!position.coords.longitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lng</h5></div></>, GConf.TostInternetGonf)}
                else{
                    setMyPosition([position.coords.latitude, position.coords.longitude])
                    setPosition({Lat:position.coords.latitude, Lng:position.coords.longitude})
                    console.log({Lat:position.coords.latitude, Lng:position.coords.longitude})
                }
            },
            function(error) {
                toast.error(<><div><h5>ENTRE VOTRE POSITION</h5></div></>, GConf.TostInternetGonf)
            }
        );
        GetDelegList(Offline.localData[0] ? Offline.localData[0].gouv : '')
    }, [])

    /*#########################[Functions]##################################*/

    /*General Info  */
    const GetDelegList = (value) =>{
        //setGouv(value)
        const found = GConf.abyedhMap.Deleg.filter(element => element.tag === value)
        setDelegList(found)
    }

    const SaveEntree = () =>{
            if (!entreData.Name) {toast.error("Nom est Invalide !", GConf.TostErrorGonf)}
            else if (!entreData.Gouv ) {toast.error("Gouv est Invalide !", GConf.TostErrorGonf)}
            else if (!entreData.Deleg) {toast.error("Deleg est Invalide !", GConf.TostErrorGonf)}
            else if (!entreData.Adress ) {toast.error("Adresse list est Invalide !", GConf.TostErrorGonf)}
            else {
                setLS(true)
                axios.post(`${GConf.ApiInputLink}/nouveaux/ajouter`, {
                    tag: selectedTag,
                    entreData: entreData,
                })
                .then(function (response) {
                    if(response.status = 200) {
                        setSaveBtnState(true)
                        setPID(response.data.PID)
                        toast.success("Facture Enregistreé !", GConf.TostSuucessGonf)
                        setLS(false)
                    }
                    else{
                        toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                        setLS(false)
                    }
                }).catch((error) => {
                    if(error.request) {
                      toast.error(<><div><h5>Probleme de Connextion</h5> La facture sera enregisstrer sur votre appareil  </div></>, GConf.TostInternetGonf)   
                      Offline.ajoutee.push(entreData)
                      localStorage.setItem(`Admin_Dir_Offline`,  JSON.stringify(Offline));
                      setLS(false)
                    }
                });

            }       
    }
 
    /*Timing  */
    const setPauseDay = (day,state) =>{
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming
        copyOfHoraire[targetIndex].dayOff = !state
        setTimming(copyOfHoraire)
    }
    const SetTimmingData = (day,time,genre,value) => {
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming

        if (time == 'matin') {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].matin.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].matin.end = value
                setTimming(copyOfHoraire)
            }
        } else {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].soir.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].soir.end = value
                setTimming(copyOfHoraire)
            }
        }

    }
 
    
    /*Position  */
    const handleLocationSelected = (location) => {
        setPosition({Lat: location.lat , Lng:location.lng})
    };
    const GetMyLocation = () =>{
        navigator.geolocation.getCurrentPosition(
            function(position) {
                if (!position.coords.latitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lat</h5></div></>, GConf.TostInternetGonf)}
                else if (!position.coords.longitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lng</h5></div></>, GConf.TostInternetGonf)}
                else{
                    setPosition({Lat:position.coords.latitude, Lng:position.coords.longitude})
                }
            },
            function(error) {
                toast.error(<><div><h5>ENTRE VOTRE POSITION</h5></div></>, GConf.TostInternetGonf)
            }
        );
    }
    
    /*Images */
    const onFileUpload = async (event) => {
        if (gettedPID) {
                setLoadingState(true)
                let file = event.target.files[0]
                const clientId = "4c61b93ac10206d"; // Ensure this is your actual Client ID
                const auth = `Client-ID ${clientId}`;

                const formData = new FormData();
                formData.append("image", file);

                try {
                    const response = await fetch("https://api.imgur.com/3/image", {
                        method: "POST",
                        body: formData,
                        headers: {
                            Authorization: auth,
                            Accept: "application/json",
                        },
                    });

                    const data = await response.json();

                    if (data.success) {
                        //alert("Image uploaded successfully");
                        setProfilePhotoData({ PID: gettedPID, ImageLink: data.data.link, Destination: data.data.deletehash })
                        setImageLink(data.data.link)
                        
                        setLoadingState(false)
                    } else {
                        setLoadingState(false)
                        alert("Upload failed");
                        console.log("Error details:", data);
                        
                    }
                } catch (err) {
                    setLoadingState(false)
                    alert("Failed to upload image");
                    console.log("Error:", err);
                }
        } else {
            alert('il faut enregister un membre d abord ')
        }
    };
    const SavePhotos = () =>{
         
        if (!imageLink.length) {toast.error('Text 1' , GConf.TostErrorGonf) }  
        else {
            axios.post(`https://api.abyedh.com/api/application/app/profile/images/ajouter`, {
                profilePhotoData: profilePhotoData
            })
            .then(response => toast.success('text 2 ', GConf.TostSuucessGonf))
            .catch(error => console.log(error));
        }
        
    }
    const DeleteImageFunc = async () => {
        const clientId = "4c61b93ac10206d"; // Ensure this is your actual Client ID
        const auth = `Client-ID ${clientId}`;

         
        try {
            const response = await fetch(`https://api.imgur.com/3/image/${toDeleteId}`, {
                method: "DELETE",
                headers: {
                    Authorization: auth, // Same auth token used for upload
                    Accept: "application/json",
                },
            });
        
            const data = await response.json();
        
            if (data.success) {
                axios.post(`https://api.abyedh.com/api/application/app/publications/delete`, {
                    toDeleteId: toDeleteId ,
                }).then(function (response) {
                    toast.success(<><div><h5>تم حذف  المنشور  بنجاح </h5>  </div></>, GConf.TostInternetGonf)
                    window.location.reload()
                })

            } else {
                alert("Delete failed");
                console.log("Error details:", data);
            }
        } catch (err) {
            alert("Failed to delete image");
            console.log("Error:", err);
        }
         
    }
    
    const handleFileSelect = async (event) => {
        const files = event.target.files;
        const formData = new FormData();
        const resizedImages = [];
    
        const resizeImage = (file, maxWidth, maxHeight) => {
            return new Promise((resolve) => {
                const img = new Image();
                const reader = new FileReader();
    
                reader.onload = (e) => {
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = maxWidth;
                        canvas.height = maxHeight;
                        const ctx = canvas.getContext("2d");
    
                        // Draw the image centered & scaled to fill 500x500
                        const ratio = Math.min(img.width / maxWidth, img.height / maxHeight);
                        const newWidth = img.width / ratio;
                        const newHeight = img.height / ratio;
                        const offsetX = (maxWidth - newWidth) / 2;
                        const offsetY = (maxHeight - newHeight) / 2;
    
                        ctx.fillStyle = "#ffffff"; // Fill background if needed
                        ctx.fillRect(0, 0, maxWidth, maxHeight);
                        ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);
    
                        canvas.toBlob((blob) => {
                            resolve(blob);
                        }, "image/jpeg", 0.9);
                    };
                    img.src = e.target.result;
                };
    
                reader.readAsDataURL(file);
            });
        };
    
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const resizedBlob = await resizeImage(file, 500, 500);
            const filename = `${selectedTag}_${gettedPID}_${i}.jpg`;
            formData.append('Images', resizedBlob, filename);
        }
    
        formData.append("PID", gettedPID);
        formData.append("SystemTag", selectedTag);
    
        const uploadedImages = Array.from(files);
        setToDisplayedImage(uploadedImages);
        setFormDataArr(formData);
    };
    const UpdateImageFuncMultiple = (formData) =>{
        if (gettedPID) {
                console.log(todisplayedImage.length)
                if (todisplayedImage.length == 0) {toast.error("Il Faut 5 Images !", GConf.TostErrorGonf) } 
                else if (todisplayedImage.length > 5) {toast.error("cinque Images Seulemment Sont autoriseé !", GConf.TostErrorGonf) } 
                else {
                    axios.post(`https://api.abyedh.com/api/application/app/profile/update/profile-pic`, formData)
                    .then(response => toast.success("Images Modifieé !", GConf.TostSuucessGonf))
                    .catch(error => console.log(error));
                }
        } else {
            alert('il faut enregister un membre d abord ')
        }
    }

    /*#########################[Component]##################################*/ 
    /*Images  */
    const ImageCard = () =>{
 
        return(<>
            <div className=" ">
                            {loadingState || imageLink != '' ? <></> : <div className='border p-2 text-center border-div shadow-sm'>
                                <label onChange={onFileUpload} htmlFor="formId"   className='text-info' role="button">
                                        <Input type='file' hidden name="Images" id="formId"  />
                                        <span className='bi bi-camera ' style={{fontSize : '40px'}}></span>
                                </label>
                            </div>}
                            {loadingState ?  <div className='text-center'><span className="spinner-border text-primary float-center"  ></span> </div>: <></>}
                            {imageLink == '' ? <></> : <img src={imageLink} className='border-div' width={'100%'} height='auto' />}
                            {imageLink == '' ? <></> :  <div className='p-1'>
                                <Button className='rounded-pill' fluid onClick={() => SavePhotos()} disabled={disabledSaveBtn} size='small' icon style={{backgroundColor:'#216e55', color:'white'}} >   Enregistrer  <Icon name='save' />   <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                            </div>}
                        </div>
                        <br />
                        <br />
        </>)
    }

    /*Profile Image  */
    const ProfileImage = () => {
        const PasDeResultat = () =>{
            return(<>
                <div className='text-center'>
                         
                        <label onChange={handleFileSelect} htmlFor="formId"   className='text-info' role="button">
                                <Input type='file' hidden name="Images" id="formId" multiple />
                                <span className='bi bi-camera text-danger' style={{fontSize : '70px'}}></span>
                                <h5 className='text-secondary'> cliquer pour ajouter une photo de profile  </h5>
                        </label>
                        
                </div>
            </>)
        }

        return  (<>
        <div className='row'>
                            {todisplayedImage.length != '0' ? 
                            <>
                                 
                                <div className='max-height-image mb-2 text-center'>
                                    <img src={URL.createObjectURL(todisplayedImage[0])} className='border rounded-circle shadow float-center mb-3' width='200px' height='200px'  />
                                </div>
                            
                                <br />
                                <div className='row  '>
                                    <div className='col-6 align-self-center'>
                                         <Button className='rounded-pill bg-danger text-white' fluid onClick={() => {setToDisplayedImage(todisplayedImage.filter((item, tindex) => tindex !== 0))}}> Annuleé </Button>
                                    </div>
                                    <div className='col-6 align-self-center text-end'>
                                            <Button   className='rounded-pill bg-system-btn'  onClick={() => UpdateImageFuncMultiple(formaDataArr)} ><Icon name='save' /> Enregistreé <Loader inverted active={loaderState} inline size='tiny' className='text-danger'/></Button>
                                    </div>
                                </div>
                                
                                
                            </>   
                            : 
                            <PasDeResultat />}
                    </div>
        </>)
    }

    /*Horaire   */
    const HoraireTabs = () => {
        const UpdateTimmingData = (day,time,genre,value) => {
            if (gettedPID) {
                
            
                    axios.post(`https://api.abyedh.com/api/systems/app/profile/update/horaire`, {
                        PID: gettedPID,
                        settingD :  timming,
                        AllTime : alwaysState
                    })
                    .then(function (response) {
                        
                        toast.success(<><div><h5>تم التعديل بنجاح </h5>  </div></>, GConf.TostInternetGonf)

                    }).catch((error) => {
                        if(error.request) {
                        toast.error(<><div><h5>Probleme de Connextion</h5> Esseyeé de connecter plus tard</div></>, GConf.TostInternetGonf) 
                        }
                    });

            } else {
                    alert('il faut enregister un membre d abord ')
            }

        }

        return(<>
             <div className="container-fluid"   >
                    <HoraireCard alwaysState={alwaysState} addInput={addInput} setAddInput={setAddInput} setAlwaysState={setAlwaysState} timming={timming} setTimming={setTimming} setPauseDay={setPauseDay} SetTimmingData={SetTimmingData} setSelectedUpdateDay={setSelectedUpdateDay} selectedUpdateDay={selectedUpdateDay} UpdateTimmingData={UpdateTimmingData} />
                    {/* <HoraireCard alwaysState={alwaysState} setAlwaysState={setAlwaysState} timming={timming} setPauseDay={setPauseDay} SetTimmingData={SetTimmingData} setSelectedUpdateDay={setSelectedUpdateDay} selectedUpdateDay={selectedUpdateDay} UpdateTimmingData={UpdateTimmingData} /> */}
                    <div className='text-center mt-4'>
                        <Button       className='rounded-pill  text-white  font-droid'  style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}} onClick={() => UpdateTimmingData()} fluid  >    modifier l'horaire <Icon name='time' />  </Button>
                    </div>
                </div>
        </>)
    }
    return (  <>
        <BackCard data={InputLinks.backCard.nv}/>
        <br />
        <div className='container-fluid'>
            <Tab menu={{  secondary: true, style: {overflowX : 'auto', overflowY : 'hidden', paddingBottom:'5px' }  }} panes={panes} />
            <br />
        </div>

    </>);
}


export default NouveauxInput;